import { lazy, Suspense } from "react";

/** `/try` is Clivie Web Lite (docs/briefs/web-lite.md): the same bundle, a
 *  different product. Decided by path, once per page load, and ahead of the
 *  desktop shell so none of its banners or editor state ever mount there.
 *
 *  Both halves load lazily so a visitor on a phone does not download the
 *  desktop editor (timeline, inspector, transcript) just to reach /try. */
const LITE = location.pathname === "/try" || location.pathname.startsWith("/try/");

const LiteApp = lazy(() => import("./lite/LiteApp"));
const DesktopApp = lazy(() => import("./DesktopApp"));

export default function App() {
  return <Suspense fallback={null}>{LITE ? <LiteApp /> : <DesktopApp />}</Suspense>;
}
